<template>
  <header class="cf-header">
    <div class="cf-header__left">
      <slot name="header-left-slot">
        <div id="header-left-slot" />
      </slot>
    </div>

    <cf-merchant-logo :logo-navigation="logoNavigation" />

    <div class="cf-header__right">
      <slot name="header-right-slot">
        <div id="header-right-slot" />
      </slot>
    </div>
  </header>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfMerchantLogo from './cf-merchant-logo/index.vue';


  export default {
    name: 'CfAppHeader',

    components: {
      CfMerchantLogo
    },

    props: {
      logoNavigation: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        scrolledToTop: true
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['currentUser']),

      isUserSignedIn() {
        return this.currentUser.accountId;
      }
    },

    mounted() {
      this.onComponentMounted();
    },

    unmounted() {
      this.onComponentDestroyed();
    },

    methods: {
      onComponentMounted() {
        window.addEventListener('scroll', this.scrollHandler);
      },

      onComponentDestroyed() {
        window.removeEventListener('scroll', this.scrollHandler);
      },

      scrollHandler() {
        this.scrolledToTop = window.scrollY < 5;
      }
    }
  };
</script>
